import React from 'react';
import { Picture, Source, Img } from '@xo-union/tk-component-picture';
import { isMobile } from "../../utilities/javascript/browser";
import styles from './styles.css';

export default class GalleryInstagramSection extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = props.isMobile;
    this.state = {
      custom_screen: isMobile ? 'mobile' : 'desktop'
    }
  }

  static defaultProps = {
    isMobile: false,
    infos: '',
    designer_name: ''
  };

  onWindowResize() {
    this.setState({
      custom_screen: isMobile() ? 'mobile' : 'desktop'
    })
  }

  componentDidMount() {
    this.onWindowResize();
    if (window && window.addEventListener) {
      window.addEventListener('resize', this.onWindowResize.bind(this))
    }
  }

  render() {
    const { infos, designer_name } = this.props;
    const { custom_screen } = this.state;
    let follow = infos['follow'] || designer_name;

    let instagramCard = function (instagram) {
      const img_id = custom_screen == 'mobile' ? instagram['mobile_img_id'] : instagram['desktop_img_id']
      let linking_url = instagram['linking_url'] || infos['linking_url'];

      return (
        <div className={styles['instagram-card']} style={{height: 0, paddingBottom: '100%'}}>
          <a className="instagram-card-link" href={linking_url} target="_blank" rel='nofollow' aria-label={infos['aria_label']}>
            <Picture id={img_id} lazy={true} pixelDensities={[1,2]}>
              <Source viewport="md" width={166} />
              <Source viewport="lg" width={215} />

              <Img width={215} alt={instagram['img_alt']} />
            </Picture>
          </a>
        </div>
      )
    }

    return (
      <div className={styles['instagram-section']}>
        <div className={styles['instagram-container']}>
          <div className={styles["section-title"]}>
            <div className={styles["instagram-description"]}>
              <span className={styles["instagram-follow"]}>Follow </span>
              <a id="instagram-designer-link" href={infos['linking_url']} target="_blank" rel='nofollow'>
                @{follow}
              </a>
            </div>
          </div>

          <div className={styles["instagram-cards"]}>
            {
              infos['imgs'].map(function (instagram, index) {
                return instagramCard(instagram)
              })
            }
          </div>
        </div>
      </div>
    )
  }
}
